<template>
  <div>
    <v-app class="daily-cargo-expand">
      <v-expansion-panels
        v-model="openedPanel"
        class="daily-cargo-expand__items"
        accordion
        @change="handlePanelChange">
        <v-expansion-panel
          v-for="(item, i) in sortedRoutes"
          :key="i">
          <v-expansion-panel-header disable-icon-rotate>
            {{ item.label }}
            <template #actions>
              <v-icon :color="getColor(item)">
                {{ getIcon(item) }}
              </v-icon>
            </template>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <daily-cargo-table />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <div v-if="sortedRoutes.length === 0">
          No saved or active flights.
        </div>
      </v-expansion-panels>
    </v-app>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      Route: null,
      openedPanel: null,
      iconDesign: {}
    }
  },
  computed: {
    ...mapState('dailyCargo', ['routeOptions']),
    ...mapGetters('dailyCargo', ['manifestGenerated']),

    sortedRoutes () {
      function compareRouteNames (a, b) {
        if (a.flightRouteName < b.flightRouteName) return -1
        if (a.flightRouteName > b.flightRouteName) return 1
        return 0
      }
      function compareLegOrder (a, b) {
        if (a.flightRouteLegOrder < b.flightRouteLegOrder) return -1
        if (a.flightRouteLegOrder > b.flightRouteLegOrder) return 1
        return 0
      }

      return this.routeOptions
        .filter(r => !r.isReturnLeg)
        .sort(compareLegOrder)
        .sort(compareRouteNames)
    }
  },
  watch: {
    '$route.params': {
      handler () {
        this.openedPanel = this.sortedRoutes.findIndex(
          r => r.value === this.$route.params.openedPanel
        )
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.loadGeneratedManifest()
  },
  methods: {
    ...mapActions('dailyCargo', ['loadDailyCargoData', 'loadGeneratedManifest']),

    // Fires once when panel changes
    async handlePanelChange (newIndex) {
      if (newIndex == null) return
      const selected = this.sortedRoutes[newIndex]
      if (!selected) return
      await this.loadDailyCargoData(selected.value)
      await this.loadGeneratedManifest()
    },

    goToIdentityCheckSheet () {
      this.$router.push('/daily-cargo-identity-check-sheet')
    },

    getColor (item) {
      const match = this.manifestGenerated.find(
        e => e.Flight_Route_ID === item.value && e.Is_Manifest_Generated
      )
      return match ? 'teal' : 'red'
    },

    getIcon (item) {
      const match = this.manifestGenerated.find(
        e => e.Flight_Route_ID === item.value && e.Is_Manifest_Generated
      )
      return match ? 'mdi-check-circle' : 'mdi-alert-circle'
    }
  }
}
</script>
<style lang="scss">
.daily-cargo-expand {
  width: 100%;
  padding-bottom: 20px;
  overflow: auto;

  &__items {
    width: 90% !important;
    padding-top: 1% !important;
  }
}
</style>
